export const serviceConstants = {
  REQUEST_START: 'REQUEST_START',
  REQUEST_STOP: 'REQUEST_STOP',
  REQUEST_ERROR: 'REQUEST_ERROR',

  FETCH_COUNTERS_FOR_BOAT_SUCCESS: 'FETCH_COUNTERS_FOR_BOAT_SUCCESS',
  FETCH_FILTERED_COUNTERS_FOR_BOAT_SUCCESS: 'FETCH_FILTERED_COUNTERS_FOR_BOAT_SUCCESS',
  FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_LOADING: 'FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_LOADING',
  FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_SUCCESS: 'FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_SUCCESS',
  FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_ERROR: 'FETCH_COUNTERS_WITH_LOGS_FOR_BOAT_ERROR',
  FETCH_REFUEL_COUNTERS_FOR_DASHBOARD_SUCCESS: 'FETCH_REFUEL_COUNTERS_FOR_DASHBOARD_SUCCESS',
  FETCH_COUNTER_SERVICES_FOR_DASHBOARD_SUCCESS: 'FETCH_COUNTER_SERVICES_FOR_DASHBOARD_SUCCESS',
  FETCH_TIME_COUNTERS_FOR_DASHBOARD_SUCCESS: 'FETCH_TIME_COUNTERS_FOR_DASHBOARD_SUCCESS',
  FETCH_COUNTERS_WITH_USAGE_FOR_BOAT_SUCCESS: 'FETCH_COUNTERS_WITH_USAGE_FOR_BOAT_SUCCESS',
  FETCH_COUNTERS_WITH_USAGE_FOR_EQUIPMENT_TEMPLATE: 'FETCH_COUNTERS_WITH_USAGE_FOR_EQUIPMENT_TEMPLATE',
  FETCH_BOAT_COUNTER_TYPES_SUCCESS: 'FETCH_BOAT_COUNTER_TYPES_SUCCESS',
  FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_LOADING: 'FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_LOADING',
  FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_SUCCESS: 'FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_SUCCESS',
  FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_ERROR: 'FETCH_SERVICES_OVERVIEW_FOR_EQUIPMENT_ERROR',

  FETCH_SERVICE_HISTORY_FOR_BOAT_LOADING: 'FETCH_SERVICE_HISTORY_FOR_BOAT_LOADING',
  FETCH_SERVICE_HISTORY_FOR_BOAT_SUCCESS: 'FETCH_SERVICE_HISTORY_FOR_BOAT_SUCCESS',
  FETCH_SERVICE_HISTORY_FOR_BOAT_ERROR: 'FETCH_SERVICE_HISTORY_FOR_BOAT_ERROR',

  CREATE_BOAT_COUNTER_SUCCESS: 'CREATE_BOAT_COUNTER_SUCCESS',

  CREATE_BOAT_COUNTER_LOG_SUCCESS: 'CREATE_BOAT_COUNTER_LOG_SUCCESS',

  CREATE_SERVICE_SUCCESS: 'CREATE_SERVICE_SUCCESS',
  UPDATE_SERVICE_SUCCESS: 'UPDATE_SERVICE_SUCCESS',

  CREATE_SERVICE_CONTROL_SUCCESS: 'CREATE_SERVICE_CONTROL_SUCCESS',

  FETCH_SERVICES_SUCCESS: 'FETCH_SERVICES_SUCCESS',

  FETCH_CALENDAR_SERVICES_LOADING: 'FETCH_CALENDAR_SERVICES_LOADING',
  FETCH_CALENDAR_SERVICES_SUCCESS: 'FETCH_CALENDAR_SERVICES_SUCCESS',
  FETCH_CALENDAR_SERVICES_FOR_EQUIPMENT_SUCCESS: 'FETCH_CALENDAR_SERVICES_FOR_EQUIPMENT_SUCCESS',
  FETCH_CALENDAR_SERVICES_ERROR: 'FETCH_CALENDAR_SERVICES_ERROR',

  FETCH_UNITS_SUCCESS: 'FETCH_UNITS_SUCCESS',

  RESET_SERVICES: 'RESET_SERVICES',

  FETCH_SERVICES_FOR_EQUIPMENT_SUCCESS: 'FETCH_SERVICES_FOR_EQUIPMENT_SUCCESS',
  FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_LOADING: 'FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_LOADING',
  FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_SUCCESS: 'FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_SUCCESS',
  FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_ERROR: 'FETCH_COUNTER_SERVICES_FOR_EQUIPMENT_COMPARISON_ERROR',

  FETCH_SERVICES_FOR_BOAT_DASHBOARD_LOADING: 'FETCH_SERVICES_FOR_BOAT_DASHBOARD_LOADING',
  FETCH_SERVICES_FOR_BOAT_DASHBOARD_SUCCESS: 'FETCH_SERVICES_FOR_BOAT_DASHBOARD_SUCCESS',
  FETCH_SERVICES_FOR_BOAT_DASHBOARD_ERROR: 'FETCH_SERVICES_FOR_BOAT_DASHBOARD_ERROR',
} as const
